<template>
  <div class="login-select-org">
    <div class="title">请选择您要登录的组织机构</div>
    <div class="org-list">
      <div
        @click="active = item.orgId"
        :class="{active: item.orgId === active}"
        class="org-item"
        v-for="(item, index) in orgLists"
        :key="index"
      >
        <img v-if="item.unitAttr == 8" src="@/assets/image/type2.png" alt="" />
        <img v-else src="@/assets/image/type1.png" alt="" />
        <div class="org-name van-ellipsis">{{ item.displayName }}</div>
      </div>
    </div>
    <div class="btn-container">
      <van-button @click="save" round block type="info">
        提交
      </van-button>
    </div>
  </div>
</template>

<script>
import {login} from '@/api'
import {getUrlMap} from '@/ultis'
export default {
  data() {
    return {
      orgLists: [],
      active: ''
    }
  },
  created() {
    this.orgLists = JSON.parse(localStorage.getItem('orgList') || '[]')
    this.basicInfo = JSON.parse(localStorage.getItem('basicInfo') || '{}')
  },
  mounted() {
    this.redirect = getUrlMap(location.href).redirect
  },
  methods: {
    save() {
      if (!this.active) {
        this.$Toast.fail('请选择机构')
        return
      }
      const params = {
        checkCode: '',
        checkCodeSessionId: '',
        loginType: '',
        orgId: this.active,
        password: this.basicInfo.password,
        userName: this.basicInfo.username,
        tenantId: ''
      }
      login(params).then(res => {
        const {operationType} = res.data
        if (operationType === 5) {
          localStorage.removeItem('orgList')
          localStorage.removeItem('basicInfo')
          const token = 'Bearer ' + res.data.userToken.accessToken
          localStorage.setItem('Authorization', token)
          if (this.redirect) {
            location.replace(decodeURIComponent(this.redirect))
          } else {
            this.$router.replace('/')
          }
        }
        if (operationType === 2) {
          this.$router.push({
            path: '/resetDefaultPwd',
            query: {
              mustResetPwdId: res.data.mustResetPwdId
            }
          })
        }
        if (operationType === 0) {
          this.$Toast.fail(res.msg)
        }
        if (operationType === 1) {
          this.$Toast.fail(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-select-org {
  height: 100vh;
  background: #fff;
  .title {
    color: #909399;
    font-size: 14px;
    padding: 14px 16px;
  }
  .org-list {
    min-height: 210px;
    max-height: calc(100vh - 150px);
    overflow-y: scroll;
  }
  .org-item {
    height: 70px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    img {
      width: 48px;
      height: 48px;
    }
    .org-name {
      flex: 1;
      margin-left: 10px;
    }
    &.active {
      background: rgba(68, 101, 243, 0.1);
      color: #4465f3;
    }
  }
  .btn-container {
    width: 90%;
    margin: 20px auto;
  }
}
</style>
